module.exports = __webpack_public_path__ + "img/58.f8f048c1.png";